const SVG_EXT_RE = /\.svg(?:[?#].*)?$/i;

function isSvgSource(src) {
  return SVG_EXT_RE.test(String(src || ""));
}

export function loadMapSymbolImage(map, id, src) {
  return new Promise((resolve) => {
    if (!map || !id || !src || map.hasImage(id)) {
      resolve(false);
      return;
    }

    const finish = (image) => {
      try {
        if (image && !map.hasImage(id)) {
          map.addImage(id, image);
          resolve(true);
          return;
        }
      } catch (error) {
        console.error(`[map-symbol] addImage failed for ${id}`, error);
      }
      resolve(false);
    };

    if (!isSvgSource(src)) {
      map.loadImage(src, (err, image) => {
        if (err) {
          console.error(`[map-symbol] loadImage failed for ${id}`, err);
        }
        finish(image);
      });
      return;
    }

    const image = new Image();
    image.decoding = "async";
    image.onload = () => finish(image);
    image.onerror = (err) => {
      console.error(`[map-symbol] SVG image load failed for ${id}`, err);
      resolve(false);
    };
    image.src = src;
  });
}

export function preloadMapSymbolImages(map, labels) {
  return Promise.all(
    (labels || []).map(({ id, src }) => loadMapSymbolImage(map, id, src))
  );
}
